export default __webpack_public_path__ + "static/bannerMobile-6ac40e9f16b058b978d0aaac69604d12.png";